import { defineComponent as _defineComponent } from 'vue'
export type Props = {
  attach: string
  label: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TlmCheckoutMenu',
  props: {
    attach: { default: 'menu-content' },
    label: { default: 'Menu' }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})